var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "editorProcess"
  }, [_c('div', {
    ref: "processCanvas",
    staticClass: "canvas",
    attrs: {
      "id": "editor-process"
    },
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
      },
      "dragenter": function ($event) {
        $event.preventDefault();
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.onDrop($event);
      }
    }
  }), _c('editorOptions', {
    attrs: {
      "diagram": _vm.diagram
    }
  }, [_c('div', {
    staticClass: "diagramAddOn"
  }, [_c('div', {
    staticClass: "overviewWrap"
  }), _c('div', {
    staticClass: "overview_wrap"
  }, [_c('div', {
    staticClass: "overview",
    class: {
      on: _vm.overviewStatus
    }
  }, [_c('div', {
    staticClass: "title_area"
  }, [_c('strong', {
    staticClass: "tit"
  }, [_vm._v("Map")])]), _c('div', {
    staticClass: "editor_overview",
    attrs: {
      "id": "editor-overview"
    }
  })])])])]), _c('contextMenuTemplate', {
    attrs: {
      "slctType": _vm.slctType
    },
    on: {
      "callOpenDictionaryPopup": _vm.callOpenDictionaryPopup,
      "contextMounted": _vm.getContext
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  }), _c('TagOptionPopWrap', {
    on: {
      "setPosition": _vm.setPosition
    }
  }), _c('TagOptionPopTagList', {
    on: {
      "callOpenDictionaryPopup": _vm.callOpenDictionaryPopup
    }
  }), _c('BalloonTemplateData'), _c('SaveLogPopup', {
    attrs: {
      "crntObj": _vm.SaveLogPopupObj
    }
  }), _c('releasePopup', {
    attrs: {
      "openFlag": _vm.PublishPopupObj.openBln
    },
    on: {
      "update:openFlag": function ($event) {
        return _vm.$set(_vm.PublishPopupObj, "openBln", $event);
      },
      "update:open-flag": function ($event) {
        return _vm.$set(_vm.PublishPopupObj, "openBln", $event);
      },
      "saveDiagram": _vm.saveDiagram,
      "orderApply": _vm.orderApply
    }
  }), _c('LogListPopup', {
    attrs: {
      "crntObj": _vm.LogListPopupObj
    }
  }), _c('CreateOrConnectPopup', {
    attrs: {
      "crntObj": _vm.CreateOrConnectPopup
    },
    on: {
      "connect-protocol": function ($event) {
        return _vm.connectProtocol($event);
      }
    }
  }), _c('dictionaryPopup', {
    attrs: {
      "crntObj": _vm.dictionaryPopup,
      "checkedTagDictionaryId": _vm.checkedTagDictionaryId
    },
    on: {
      "update:checkedTagDictionaryId": function ($event) {
        _vm.checkedTagDictionaryId = $event;
      },
      "update:checked-tag-dictionary-id": function ($event) {
        _vm.checkedTagDictionaryId = $event;
      }
    }
  }), _c('ProcessSearch', {
    attrs: {
      "type": 'onlyProtocol',
      "searchLinkData": _vm.searchLinkData
    },
    on: {
      "select-protocol": function ($event) {
        return _vm.selectProtocol($event);
      },
      "setMethod": function ($event) {
        return _vm.getChildMethods($event);
      }
    }
  }), _c('editor-btm-option', {
    attrs: {
      "openLogListPopup": _vm.openLogListPopup,
      "openSaveLogPopup": _vm.openSaveLogPopup,
      "openPublishPopup": _vm.openPublishPopup,
      "processData": _vm.processData
    },
    on: {
      "gridVisible": _vm.gridVisible,
      "saveRequest": _vm.saveDiagram,
      "endEditProcess": _vm.endEditProcess,
      "orderApply": _vm.orderApply
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.editStatusAlert,
      expression: "editStatusAlert"
    }],
    staticClass: "modalPopupLayout active"
  }, [_c('div', {
    staticClass: "contentWrap"
  }, [_c('h2', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.editStatusTitle))]), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center",
      "width": "300px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.editStatusContent)
    }
  })]), _c('div', {
    staticClass: "ctrl",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "sm_btn color_2",
    on: {
      "click": function ($event) {
        return _vm.$router.go(_vm.$router.currentRoute);
      }
    }
  }, [_vm._v("확인")])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }